import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as $11sjw$useState, useRef as $11sjw$useRef, useCallback as $11sjw$useCallback } from "react";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $bfee1151ccb0650f$exports = {};
$parcel$export($bfee1151ccb0650f$exports, "useControlledState", function () {
  return $bfee1151ccb0650f$export$40bfa8c7b0832715;
});

function $bfee1151ccb0650f$export$40bfa8c7b0832715(value1, defaultValue, onChange) {
  var _$11sjw$useState = $11sjw$useState(value1 || defaultValue),
      _$11sjw$useState2 = _slicedToArray(_$11sjw$useState, 2),
      stateValue = _$11sjw$useState2[0],
      setStateValue = _$11sjw$useState2[1];

  var ref = $11sjw$useRef(value1 !== undefined);
  var wasControlled = ref.current;
  var isControlled = value1 !== undefined; // Internal state reference for useCallback

  var stateRef = $11sjw$useRef(stateValue);
  if (wasControlled !== isControlled) console.warn("WARN: A component changed from ".concat(wasControlled ? 'controlled' : 'uncontrolled', " to ").concat(isControlled ? 'controlled' : 'uncontrolled', "."));
  ref.current = isControlled;
  var setValue = $11sjw$useCallback(function (value2) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var onChangeCaller = function onChangeCaller(value) {
      if (onChange) {
        for (var _len2 = arguments.length, onChangeArgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          onChangeArgs[_key2 - 1] = arguments[_key2];
        }

        if (!Object.is(stateRef.current, value)) onChange.apply(void 0, [value].concat(onChangeArgs));
      }

      if (!isControlled) stateRef.current = value;
    };

    if (typeof value2 === 'function') {
      console.warn('We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320'); // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
      // when someone using useControlledState calls setControlledState(myFunc)
      // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
      // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
      // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same

      var updateFunction = function updateFunction(oldValue) {
        for (var _len3 = arguments.length, functionArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          functionArgs[_key3 - 1] = arguments[_key3];
        }

        var interceptedValue = value2.apply(void 0, [isControlled ? stateRef.current : oldValue].concat(functionArgs));
        onChangeCaller.apply(void 0, [interceptedValue].concat(args));
        if (!isControlled) return interceptedValue;
        return oldValue;
      };

      setStateValue(updateFunction);
    } else {
      if (!isControlled) setStateValue(value2);
      onChangeCaller.apply(void 0, [value2].concat(args));
    }
  }, [isControlled, onChange]); // If a controlled component's value prop changes, we need to update stateRef

  if (isControlled) stateRef.current = value1;else value1 = stateValue;
  return [value1, setValue];
}

var $48d9f1d165180307$exports = {};
$parcel$export($48d9f1d165180307$exports, "clamp", function () {
  return $48d9f1d165180307$export$7d15b64cf5a3a4c4;
});
$parcel$export($48d9f1d165180307$exports, "snapValueToStep", function () {
  return $48d9f1d165180307$export$cb6e0bb50bc19463;
});
$parcel$export($48d9f1d165180307$exports, "toFixedNumber", function () {
  return $48d9f1d165180307$export$b6268554fba451f;
});

function $48d9f1d165180307$export$7d15b64cf5a3a4c4(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -Infinity;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
  var newValue = Math.min(Math.max(value, min), max);
  return newValue;
}

function $48d9f1d165180307$export$cb6e0bb50bc19463(value, min, max, step) {
  var remainder = (value - (isNaN(min) ? 0 : min)) % step;
  var snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;

  if (!isNaN(min)) {
    if (snappedValue < min) snappedValue = min;else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
  } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step; // correct floating point behavior by rounding to step precision


  var string = step.toString();
  var index = string.indexOf('.');
  var precision = index >= 0 ? string.length - index : 0;

  if (precision > 0) {
    var pow = Math.pow(10, precision);
    snappedValue = Math.round(snappedValue * pow) / pow;
  }

  return snappedValue;
}

function $48d9f1d165180307$export$b6268554fba451f(value, digits) {
  var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var pow = Math.pow(base, digits);
  return Math.round(value * pow) / pow;
}

export { $bfee1151ccb0650f$export$40bfa8c7b0832715 as useControlledState, $48d9f1d165180307$export$7d15b64cf5a3a4c4 as clamp, $48d9f1d165180307$export$cb6e0bb50bc19463 as snapValueToStep, $48d9f1d165180307$export$b6268554fba451f as toFixedNumber };